// extracted by mini-css-extract-plugin
export default {"box":"SvgAnimationBox__box-sGVh","loading":"SvgAnimationBox__loading-GexG"};